let shipping = {
    now: new Date(),
    postcode: null,
    warehouses: {
        5850366007: { "index": 0, "id": 5850366007, "zip": "98006", "name": "4473 163RD PL SE" },
        70960414975: { "index": 1, "id": 70960414975, "zip": "75007", "name": "Dallas, TX Warehouse" },
        70971687167: { "index": 2, "id": 70971687167, "zip": "17001", "name": "Harrisburg, PA Warehouse" },
        61350445224: { "index": 1, "id": 61350445224, "zip": null, "name": "Flowspace" },
        61448519848: { "index": 2, "id": 61448519848, "zip": "19007", "name": "Flowspace - Bristol, PA - LZ Inventory" },
        61448487080: { "index": 3, "id": 61448487080, "zip": "19007", "name": "Flowspace - Bristol, PA - USA Inventory" },
        61448192168: { "index": 4, "id": 61448192168, "zip": "91748", "name": "Flowspace - Los Angeles (City of Industry) - LZ Inventory" },
        61311320232: { "index": 5, "id": 61311320232, "zip": "91748", "name": "Flowspace - Los Angeles (City of Industry) - USA Inventory" },
        63623102632: { "index": 6, "id": 63623102632, "zip": "35601", "name": "Decatur, AL Warehouse" }
    },
    init(mini_cart = false) {
        this.isCheckout = document.body.classList.contains('template-checkout');
        this.zipInputSelector = this.isCheckout ? '#checkout_shipping_address_zip' : '.shipping_information #zip';
        this.cutOffTimeDest = document.querySelector('.shipping_information .cut-off-time');

        this.checkInventory(mini_cart);
        this.enableTooltip();
        this.defineInput();
        this.firstDelivery();

        if (localStorage.getItem('zip') === null) {
            $('.input_fields').show();
            $('.clearButton').hide();
        } else {
            this.postcode = localStorage.getItem('zip');
            $('.shipping_information-pdp .input_fields').hide();
            $('.clearButton').show();
        }

    },
    firstDelivery() {

        let date_min = this.defineDate(parseInt(shipping_time.min), this.chooseWarehouse()),
            calc_min = this.buildDate(date_min);
        let date_max = this.defineDate(parseInt(shipping_time.max), this.chooseWarehouse()),
            calc_max = this.buildDate(date_max);
        $('.deliver_by_range').text(calc_min + ' - ' + calc_max);

        this.setZipCartAttribute(calc_min + ' - ' + calc_max);
    },
    chooseWarehouse() {
        let days = 100, warehouse = 0;
        processing_times.forEach(function (item, index) {
            if (days > item) {
                days = item;
                warehouse = index;
            }
        });
        return warehouse;
    },
    enableTooltip: function () {
        $('.info-icon').on('click', function () {
            $(this).toggleClass('hover')
        });
        $('body').on('click', function (e) {
            if ($(e.target).closest(".info-icon").length === 0 && $(e.target).closest(".tooltip-shipping").length === 0) {
                $('.info-icon').removeClass('hover')
            }
        })
    },
    buildDate: function (date) {
        switch (shipping_date_format) {
            case "week_day_month":
                // Thursday  April 9th
                return this.getWeekDay(date.getDay()) + ' ' +
                    this.getMonth(date.getMonth()) + ' ' +
                    date.getDate();
                break;
            case "month_day_year":
                // 04/09/2021
                return (date.getMonth() < 9 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
                    + '/' + (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + '/' + date.getFullYear();
                break;
            case "day_month":
                // April  9th
                return this.getMonth(date.getMonth()) + ' '
                    + date.getDate();
                break;
        }
        return this.getWeekDay(date.getDay()) + ' ' + date.getDate() + ' ' + this.getMonth(date.getMonth()) + ' ' + date.getFullYear();
    },
    defineInput: function () {
        $(this.zipInputSelector).on('change', function () {
            if ($(this).val() == '') {
                $('.before-input').show();
                $('.after-input, .error-msg').hide();
                localStorage.clear();
                $('.clearButton').hide();
                $('.input_fields').show();
                return;
            }
            shipping.postcode = $(this).val();
            shipping.getState($(this).val());
            if (shipping.stateCode != 'none') {
                shipping.calcPostCode();
                shipping.setCutOffTime();
                $('.clearButton').show();
                $('.shipping_information-pdp .input_fields').hide();
            }
        });

        $(this.zipInputSelector).on('keyup', function () {
            if ($(this).val().length == 5) {
                shipping.getState($(this).val());
                if (shipping.stateCode != 'none') {
                    shipping.calcPostCode();
                    shipping.setCutOffTime();
                    $('.clearButton').show();
                    $('.shipping_information-pdp .input_fields').hide();
                }
            }
            if ($(this).val() == '') {
                $('.before-input').show();
                $('.after-input, .error-msg').hide();
                localStorage.clear();
                $('.clearButton').hide();
                $('.input_fields').show();
                return;
            }
            $('.clearButton').on('click', function () {
                $(shipping.zipInputSelector).val('');
                $('.before-input').show();
                $('.after-input, .error-msg').hide();
                $('.input_fields').show();
                localStorage.clear();
                $(this).hide();
            });

        });
        // Event listener for the clear button
        $('body').on('click', '.clearButton', function () {
            $(shipping.zipInputSelector).val('');
            $('.before-input').show();
            $('.after-input, .error-msg').hide();
            // Show the .input_fields section
            $('.input_fields').show();
            localStorage.clear();
            $(this).hide();
        });
    },
    validatePostcode: function (postcode) {
        // US regex
        let regex = /^\d{5}([\-]?\d{4})?$/gm;
        let match_ = postcode.match(regex);
        if (match_ == null) {
            return false;
        }
        return true;
    },
    calcPostCodeCart: function () {
        $.ajax({
            url: "/cart/prepare_shipping_rates.json",
            dataType: 'json',
            type: 'POST',
            data: {
                shipping_address: {
                    zip: shipping.postcode,
                    country: 'United States',
                    province: shipping.state
                }
            }, success: function (data) {
                setTimeout(function () {
                    $.ajax({
                        url: "/cart/async_shipping_rates.json",
                        dataType: 'json',
                        type: 'GET',
                        success: function (data) {
                            if (data == null) {
                                shipping.calcPostCodeCart()
                            } else {
                                shipping.handleShipping(data.shipping_rates);
                            }
                        }
                    });
                }, 150)
            },
            error: function () {
                $('.error-msg').show();
                $('.delivery-text-inner').removeClass('loading');
                $('.delivery-date-loader').hide();
            }
        })
    },
    calcPostCode: function () {
        $('.delivery-text-inner').addClass('loading');
        $('.delivery-date-loader').show();
        $('.after-input, .error-msg, .before-input').hide();
        if (shipping_by_app) {
            $.ajax({
                url: "/apps/postcode-shipping/quote",
                dataType: 'json',
                type: 'GET',
                data: {
                    postal_code: shipping.postcode,
                    country: 'US',
                    province: shipping.state
                },
                success: function (data) {
                    console.log(data)
                    if (data["rates"]) {
                        shipping.handleShipping(data.rates);
                    }
                    else {
                        $('.error-msg').show();
                        $('.delivery-text-inner').removeClass('loading');
                        $('.delivery-date-loader').hide();
                    }
                }
            });
        } else {
            if ($('body').hasClass('product')) {
                $.ajax({
                    url: '/cart.js',
                    type: 'GET',
                    dataType: 'json',
                    success: function (params) {
                        localStorage.setItem('oldCart', JSON.stringify(params.items))
                        $.ajax({
                            url: '/cart/clear.js',
                            type: 'POST',
                            success: function (params) {
                                $.ajax({
                                    url: '/cart/add.js',
                                    type: 'GET',
                                    data: {
                                        id: $('form.product-form [name=id]').val(),
                                        quantity: 1
                                    },
                                    success: function (params) {
                                        $.ajax({
                                            url: "/cart/prepare_shipping_rates.json",
                                            dataType: 'json',
                                            type: 'POST',
                                            data: {
                                                shipping_address: {
                                                    zip: shipping.postcode,
                                                    country: 'United States',
                                                    province: shipping.state
                                                }
                                            },
                                            success: function (data) {
                                                setTimeout(function () {
                                                    shipping.getShipping(console.log)
                                                }, 150)
                                            },
                                            error: function (error) {
                                                $('.error-msg').show();
                                                $('.delivery-text-inner').removeClass('loading');
                                                $('.delivery-date-loader').hide();
                                            }
                                        })
                                    }
                                });
                            }
                        });
                    }
                })
            } else {
                this.calcPostCodeCart();
            }
        }
    },
    getShipping: function (setCallback) {
        $.ajax({
            url: "/cart/async_shipping_rates.json",
            dataType: 'json',
            type: 'GET',
            success: function (data) {
                if (data == null) {
                    setTimeout(function () {
                        shipping.getShipping(setCallback)
                    }, 150)
                } else {
                    shipping.handleShipping(data.shipping_rates);
                    $.ajax({
                        url: '/cart/clear.js',
                        type: 'POST',
                        success: function (params) {
                            let oldCart = JSON.parse(localStorage.getItem('oldCart'));
                            if (oldCart.length > 0) {
                                Shopify.queue = oldCart;
                                Shopify.moveAlong = function () {
                                    if (Shopify.queue.length) {
                                        var request = Shopify.queue.shift();
                                        $.ajax({
                                            type: "POST",
                                            url: "/cart/add.js",
                                            data: request,
                                            success: function success(res) {
                                                Shopify.moveAlong();
                                            },
                                            error: function error() {
                                                if (Shopify.queue.length) {
                                                    Shopify.moveAlong()
                                                } else {
                                                    console.log('done')
                                                }
                                            }
                                        })
                                    } else {
                                        console.log('done')
                                    }
                                };
                                Shopify.moveAlong()
                            }
                        }
                    });

                }
            }
        });
    },
    addDays: function (theDate, days) {
        return new Date(theDate.getTime() + days * 24 * 60 * 60 * 1000);
    },
    getWeekDay: function (day) {
        let weekday = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        return weekday[day];
    },
    getMonth: function (month) {
        let months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
        return months[month];
    },
    defineDate: function (days, warehouse = 0) {
        let date = this.checkOff(this.now, days + parseInt(processing_times[warehouse]));
        return date;
    },
    checkOff: function (dispatch, days) {
        let off = 0, newDate, date_str, new_dispatch = new Date(dispatch);
        while (off < days) {
            newDate = new Date(new_dispatch.setDate(new_dispatch.getDate() + 1));
            date_str = (newDate.getDate() < 10 ? '0' + newDate.getDate() : newDate.getDate()) +
                '/' + ((newDate.getMonth() + 1) < 10 ? '0' + (newDate.getMonth() + 1) : (newDate.getMonth() + 1));
            if (newDate.getDay() != 0 && newDate.getDay() != 6 && !shipping_days_off.includes(date_str)) {
                //Date.getDay() gives weekday starting from 0(Sunday) to 6(Saturday)
                off++;
            }
        }
        return newDate;
    },
    checkInventory(mini_cart) {
        let product_ids = '';
        if (mini_cart) {
            $('#CartDrawer-Form').serializeArray().forEach(function (value) {
                if (value.name == "product_ids[]") {
                    product_ids += value.value + ',';
                }
            })
        } else {
            product_ids = $('.product-variant-id').val();
        }

        fetch('https://titancasket.mizu.a2hosted.com/index.php?id=' + product_ids)
            .then(res => res.text())
            .then(data => {
                if (data.length > 0) {
                    try {
                        data = JSON.parse(data);
                        shipping.available = data.inventory_levels;
                    } catch (error) {
                        shipping.available = false;
                    }
                }
                let zip = localStorage.getItem('zip'), state = localStorage.getItem('state');
                if (zip != null || zip != undefined) {
                    $('#zip').val(zip);
                    $('#zip').trigger('change')
                }
                if (state != null) {
                    this.state = state;
                }
                if (state != null && zip != null) {
                    $('#zip').trigger('change')
                }
            });

    },
    // for front-end
    handleShipping: function (rates) {
        localStorage.setItem('zip', shipping.postcode);
        let rate = rates[0], days, warehouse = false, available_warehouses = [];
        if (this.available) {
            this.available.forEach(function (location, index) {
                if (location.available > 0) {
                    available_warehouses[available_warehouses.length] = location.location_id;
                }
            });
            available_warehouses.forEach(function (id, index) {
                if (shipping.warehouses[id] != null) {
                    available_warehouses[index] = shipping.warehouses[id].index;
                }
            });
            if (available_warehouses.length == 1) {
                warehouse = available_warehouses[0];
            }
        }
        let count_days = 100;
        rates.forEach(el => {
            let reg = parseInt(el.description.match(/\d+/)),
                temp_warehouse = parseInt(el.service_code.match(/\d+/)) - 1;
            reg += processing_times[temp_warehouse];
            if (reg < count_days &&
                (available_warehouses.length > 0 && available_warehouses.includes(temp_warehouse))) {
                rate = el;
                count_days = reg;
                if (available_warehouses.length != 1) {
                    warehouse = temp_warehouse;
                }
            }
        });
        if (shipping_by_app) {
            days = rate.description.match(/\d+/);
            days = (days != null) ? parseInt(days[0]) : shipping_time.max;
        } else {
            days = rate.delivery_days[0] || shipping_time.max;
        }

        if (warehouse === false) {
            warehouse = this.chooseWarehouse();
        }

        let date = shipping.defineDate(days, warehouse);
        let calc_shipping = shipping.buildDate(date);

        localStorage.setItem('shipping_date', calc_shipping);
        $('.deliver_by').text(calc_shipping);

        let calc_shipping_product = calc_shipping.split(" ")
        dateString = calc_shipping_product.slice(1).join(" ");
        $('.deliver_by_product').text(dateString);




        this.setZipCartAttribute(calc_shipping);
        this.setZipCartAttributeZip(shipping.postcode);

        $('.deliver_to').text(shipping.postcode + ' (' + shipping.state + ')');
        $('.deliver_by_product').next('.deliver_to').append('<div class="clearButton" aria-label="Close"></div>');

        $('.before-input').hide();
        $('.after-input').show();
        $('.delivery-text-inner').removeClass('loading');
        $('.delivery-date-loader').hide();

        localStorage.setItem('zip', shipping.postcode)
        localStorage.setItem('state', shipping.state)
    },
    setZipCartAttribute(val) {
        let zipCartAttr = document.getElementById('ZipCartAttr');

        if (this.isCheckout) {
            zipCartAttr = document.getElementById('EtaAttr');
        } else if (window.location.pathname === '/cart') {
            $.ajax({
                type: "POST",
                url: window.Shopify.routes.root + 'cart/update.js',
                data: {
                    attributes: {
                        eta: val
                    }
                },
                success: function (response) {
                }
            });
        }


        if (zipCartAttr) {
            zipCartAttr.value = val;
        }
    },
    setZipCartAttributeZip(val) {
        let zipCartAttr = document.getElementById('ZipCartAttrZip');

        if (this.isCheckout) {
            zipCartAttr = document.getElementById('ZipAttr');
            val = document.getElementById('checkout_shipping_address_zip').value;
        } else if (window.location.pathname === '/cart') {
            $.ajax({
                type: "POST",
                url: window.Shopify.routes.root + 'cart/update.js',
                data: {
                    attributes: {
                        zip: val
                    }
                },
                success: function (response) {
                }
            });
        }


        if (zipCartAttr) {
            zipCartAttr.value = val;
        }
    },
    getState(zipString) {

        /* Ensure param is a string to prevent unpredictable parsing results */
        if (typeof zipString !== 'string') {
            console.log('Must pass the zipcode as a string.');
            return;
        }

        /* Ensure we have exactly 5 characters to parse */
        if (zipString.length !== 5) {
            console.log('Must pass a 5-digit zipcode.');
            return;
        }

        /* Ensure we don't parse strings starting with 0 as octal values */
        const zipcode = parseInt(zipString, 10);

        let st;
        let state;

        /* Code cases alphabetized by state */
        if (zipcode >= 35000 && zipcode <= 36999) {
            st = 'AL';
            state = 'Alabama';
        } else if (zipcode >= 99500 && zipcode <= 99999) {
            st = 'AK';
            state = 'Alaska';
        } else if (zipcode >= 85000 && zipcode <= 86999) {
            st = 'AZ';
            state = 'Arizona';
        } else if (zipcode >= 71600 && zipcode <= 72999) {
            st = 'AR';
            state = 'Arkansas';
        } else if (zipcode >= 90000 && zipcode <= 96699) {
            st = 'CA';
            state = 'California';
        } else if (zipcode >= 80000 && zipcode <= 81999) {
            st = 'CO';
            state = 'Colorado';
        } else if ((zipcode >= 6000 && zipcode <= 6389) || (zipcode >= 6391 && zipcode <= 6999)) {
            st = 'CT';
            state = 'Connecticut';
        } else if (zipcode >= 19700 && zipcode <= 19999) {
            st = 'DE';
            state = 'Delaware';
        } else if (zipcode >= 32000 && zipcode <= 34999) {
            st = 'FL';
            state = 'Florida';
        } else if ((zipcode >= 30000 && zipcode <= 31999) || (zipcode >= 39800 && zipcode <= 39999)) {
            st = 'GA';
            state = 'Georgia';
        } else if (zipcode >= 96700 && zipcode <= 96999) {
            st = 'HI';
            state = 'Hawaii';
        } else if (zipcode >= 83200 && zipcode <= 83999) {
            st = 'ID';
            state = 'Idaho';
        } else if (zipcode >= 60000 && zipcode <= 62999) {
            st = 'IL';
            state = 'Illinois';
        } else if (zipcode >= 46000 && zipcode <= 47999) {
            st = 'IN';
            state = 'Indiana';
        } else if (zipcode >= 50000 && zipcode <= 52999) {
            st = 'IA';
            state = 'Iowa';
        } else if (zipcode >= 66000 && zipcode <= 67999) {
            st = 'KS';
            state = 'Kansas';
        } else if (zipcode >= 40000 && zipcode <= 42999) {
            st = 'KY';
            state = 'Kentucky';
        } else if (zipcode >= 70000 && zipcode <= 71599) {
            st = 'LA';
            state = 'Louisiana';
        } else if (zipcode >= 3900 && zipcode <= 4999) {
            st = 'ME';
            state = 'Maine';
        } else if (zipcode >= 20600 && zipcode <= 21999) {
            st = 'MD';
            state = 'Maryland';
        } else if ((zipcode >= 1000 && zipcode <= 2799) || (zipcode == 5501) || (zipcode == 5544)) {
            st = 'MA';
            state = 'Massachusetts';
        } else if (zipcode >= 48000 && zipcode <= 49999) {
            st = 'MI';
            state = 'Michigan';
        } else if (zipcode >= 55000 && zipcode <= 56899) {
            st = 'MN';
            state = 'Minnesota';
        } else if (zipcode >= 38600 && zipcode <= 39999) {
            st = 'MS';
            state = 'Mississippi';
        } else if (zipcode >= 63000 && zipcode <= 65999) {
            st = 'MO';
            state = 'Missouri';
        } else if (zipcode >= 59000 && zipcode <= 59999) {
            st = 'MT';
            state = 'Montana';
        } else if (zipcode >= 27000 && zipcode <= 28999) {
            st = 'NC';
            state = 'North Carolina';
        } else if (zipcode >= 58000 && zipcode <= 58999) {
            st = 'ND';
            state = 'North Dakota';
        } else if (zipcode >= 68000 && zipcode <= 69999) {
            st = 'NE';
            state = 'Nebraska';
        } else if (zipcode >= 88900 && zipcode <= 89999) {
            st = 'NV';
            state = 'Nevada';
        } else if (zipcode >= 3000 && zipcode <= 3899) {
            st = 'NH';
            state = 'New Hampshire';
        } else if (zipcode >= 7000 && zipcode <= 8999) {
            st = 'NJ';
            state = 'New Jersey';
        } else if (zipcode >= 87000 && zipcode <= 88499) {
            st = 'NM';
            state = 'New Mexico';
        } else if ((zipcode >= 10000 && zipcode <= 14999) || (zipcode == 6390) || (zipcode == 501) || (zipcode == 544)) {
            st = 'NY';
            state = 'New York';
        } else if (zipcode >= 43000 && zipcode <= 45999) {
            st = 'OH';
            state = 'Ohio';
        } else if ((zipcode >= 73000 && zipcode <= 73199) || (zipcode >= 73400 && zipcode <= 74999)) {
            st = 'OK';
            state = 'Oklahoma';
        } else if (zipcode >= 97000 && zipcode <= 97999) {
            st = 'OR';
            state = 'Oregon';
        } else if (zipcode >= 15000 && zipcode <= 19699) {
            st = 'PA';
            state = 'Pennsylvania';
        } else if (zipcode >= 300 && zipcode <= 999) {
            st = 'PR';
            state = 'Puerto Rico';
        } else if (zipcode >= 2800 && zipcode <= 2999) {
            st = 'RI';
            state = 'Rhode Island';
        } else if (zipcode >= 29000 && zipcode <= 29999) {
            st = 'SC';
            state = 'South Carolina';
        } else if (zipcode >= 57000 && zipcode <= 57999) {
            st = 'SD';
            state = 'South Dakota';
        } else if (zipcode >= 37000 && zipcode <= 38599) {
            st = 'TN';
            state = 'Tennessee';
        } else if ((zipcode >= 75000 && zipcode <= 79999) || (zipcode >= 73301 && zipcode <= 73399) || (zipcode >= 88500 && zipcode <= 88599)) {
            st = 'TX';
            state = 'Texas';
        } else if (zipcode >= 84000 && zipcode <= 84999) {
            st = 'UT';
            state = 'Utah';
        } else if (zipcode >= 5000 && zipcode <= 5999) {
            st = 'VT';
            state = 'Vermont';
        } else if ((zipcode >= 20100 && zipcode <= 20199) || (zipcode >= 22000 && zipcode <= 24699) || (zipcode == 20598)) {
            st = 'VA';
            state = 'Virgina';
        } else if ((zipcode >= 20000 && zipcode <= 20099) || (zipcode >= 20200 && zipcode <= 20599) || (zipcode >= 56900 && zipcode <= 56999)) {
            st = 'DC';
            state = 'Washington DC';
        } else if (zipcode >= 98000 && zipcode <= 99499) {
            st = 'WA';
            state = 'Washington';
        } else if (zipcode >= 24700 && zipcode <= 26999) {
            st = 'WV';
            state = 'West Virginia';
        } else if (zipcode >= 53000 && zipcode <= 54999) {
            st = 'WI';
            state = 'Wisconsin';
        } else if (zipcode >= 82000 && zipcode <= 83199) {
            st = 'WY';
            state = 'Wyoming';
        } else {
            st = 'none';
            state = 'none';
            console.log('No state found matching', zipcode);
        }
        shipping.state = state;
        shipping.stateCode = st;
        return state;
    },

    californiaTime(dt = new Date()) {
        return new Date(dt.toLocaleString('en-US', { timeZone: 'America/Los_Angeles' }));
    },
    getTimezoneName(today) {
        const short = today.toLocaleDateString(undefined);
        const full = today.toLocaleDateString(undefined, { timeZoneName: 'short' });

        const shortIndex = full.indexOf(short);
        if (shortIndex >= 0) {
            const trimmed = full.substring(0, shortIndex) + full.substring(shortIndex + short.length);
            return trimmed.replace(/^[\s,.\-:;]+|[\s,.\-:;]+$/g, '');
        } else {
            return full;
        }
    },
    formatAMPM(date) {
        let hours = date.getHours();
        let minutes = date.getMinutes();
        let ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;
        let strTime = hours + ':' + minutes + ' ' + ampm + ' ' + this.getTimezoneName(date);
        return strTime;
    },
    convertMsToHM(milliseconds, number = false, return_minutes = false) {
        let seconds = Math.floor(milliseconds / 1000);
        let minutes = Math.floor(seconds / 60);
        let hours = Math.floor(minutes / 60);

        seconds = seconds % 60;
        minutes = seconds >= 30 ? minutes + 1 : minutes;

        minutes = minutes % 60;

        hours = hours % 24;

        if (return_minutes) {
            return minutes;
        }
        return hours;
    },
    setCutOffTime() {
        if (this.cutOffTimeDest != null) {
            let cutOffTimeText = '';


            const timeNow = new Date();
            const cutOffTime = (new Date(
                this.californiaTime()
                    .setHours(
                        cut_off_time.shipping_estimator_cut_off_time_hr,
                        cut_off_time.shipping_estimator_cut_off_time_min,
                        0)
            ));

            const hours_left = this.convertMsToHM(cutOffTime.getTime() - this.californiaTime().getTime());
            if (hours_left < cut_off_time.shipping_estimator_change_red) {
                this.cutOffTimeDest.classList.add('text-red');
            }
            // static
            if (cut_off_time.show_static_version) {
                const hours = this.convertMsToHM(cutOffTime.getTime() - this.californiaTime().getTime(), true);
                const day_before = timeNow.getDate();
                timeNow.setHours(timeNow.getHours() + hours, 0, 0);
                const day_after = timeNow.getDate();
                if (day_before === day_after) {
                    cutOffTimeText = cut_off_time.shipping_estimator_cut_off_time_static
                        .replace(/{time}/g, this.formatAMPM(cutOffTime));
                }
            }
            // dynamic
            else if (cut_off_time.show_dynamic_version) {
                const minutes = this.convertMsToHM(cutOffTime.getTime() - this.californiaTime().getTime(), false, true);
                if (hours_left >= 0 && minutes >= 0) {
                    cutOffTimeText = cut_off_time.shipping_estimator_cut_off_time_dynamic
                        .replace(/{hours}/g, hours_left)
                        .replace(/{minutes}/g, minutes);
                }
            }

            this.cutOffTimeDest.innerHTML = cutOffTimeText;
        }
    }

}
shipping.init();
